// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__jFd5H","buttonTextWhite":"Button_buttonTextWhite__1-GxB","buttonTextGrey":"Button_buttonTextGrey__eTxvS"};